import { z } from "zod";

export const DailyFilterSchema = z.object({
    property_id: z.string().uuid(), // Ensuring property_id is a valid UUID
    start_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Enforcing YYYY-MM-DD format
    end_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // Enforcing YYYY-MM-DD format
    room_type_id: z.string(), // Ensuring room_type_id is a string
    // The OTA's `code` (e.g. "ABB"), not its id — matches bookings.channex_ota_code.
    ota_code: z.string().optional(),
    agent_id: z.string().optional(),
});

export type DailyFilterType = z.infer<typeof DailyFilterSchema>;
